import { Box, Button, Chip, FormControl, FormHelperText, InputLabel, MenuItem, OutlinedInput, Select, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { TiUserAdd } from "react-icons/ti";
import { UserAPI } from '../../../api/UserAPI';
import { useSelector } from 'react-redux';
import RowDataItem from './RowDataItem';
import Loader from '../../../component/Loader';
import notFoundImg from "../../../assets/images/not-found-all.png"
import { Privileges } from '../../../util/PrivilegeConstants';
import { useDispatch } from 'react-redux';
import { rootAction } from '../../../redux/reducer/rootReducer';
import { PrivilegeAPI } from '../../../api/PrivilegesAPI';
import * as Yup from 'yup';
import CustomDialog from '../../CustomComponents/CustomDialog/CustomDialog.jsx'

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const validationObj = Yup.object({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    email: Yup.string().required("Email is required").email("Must be valid email"),
    role: Yup.array().min(1, "Select atleast 1 role")
})

const InviteStaff = () => {
    const userInfo = useSelector((store) => store.user.userInfo);
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const [openDialog, setOpenDialog] = useState({ isOpen: false, isEdit: false });
    const [loading, setLoading] = useState(false);
    const [allMember, setAllMember] = useState([])
    const [memberData, setMemberData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        role: ['STAFF']
    });
    const [errors, setErrors] = useState({});
    const [privileges, setPrivileges] = useState({});
    const dispatch = useDispatch();

    useEffect(() => {
        if (selectedClub.clubId) {
            fetchAllMember();
        }
    }, [selectedClub.clubId]);

    const findAllPrivileges = async () => {
        try {
            setLoading(true)
            const reqObj = {
                userId: userInfo.userId,
                featureName: Object.keys(Privileges)[10]
            }
            const response = await PrivilegeAPI.getAllPrivilegesByFeature(reqObj);
            setPrivileges(response.Data);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (userInfo.userId) {
            findAllPrivileges();
        }
    }, [userInfo.userId]);

    const fetchAllMember = async () => {
        try {
            setLoading(true);
            const res = await UserAPI.getAllMembersForAClub(selectedClub.clubId,0,100,'',{})
            setAllMember(res.Data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    const handleCreateMemberUser = async () => {
        try {
            await validationObj.validate(memberData, { abortEarly: false })
            const userDetails = {
                firstName: memberData.firstName?.trim(),
                lastName: memberData.lastName?.trim(),
                mobile: memberData.phone ? memberData.phone?.startsWith('+') ? memberData?.phone : "+" + memberData?.phone : "+1000000000",
                email: memberData.email.trim(),
                club: {
                    clubId: selectedClub.clubId
                },
                roleNames: memberData.role
            }

            setLoading(true);
            const response = await UserAPI.createMemberUser(userDetails);
            setAllMember(prev => [...prev, response.Data]);
            setMemberData({ role: ['STAFF'] });
            Object.keys(errors).length != 0 && setErrors({});
            setOpenDialog({ isOpen: false, isEdit: false });
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: 'Invitation sent successfully' }));
        } catch (error) {
            console.log(error);

            if (error.inner) {
                let errObj = {};
                error.inner.forEach(err => {
                    errObj[err.path] = err.message;
                })
                setErrors(errObj);
            } else {
                dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: error?.response?.data?.Data }));
            }
        } finally {
            setLoading(false);
        }
    }

    const handleMemberData = (event) => {
        const { name, value } = event.target;
        if (name === 'role') {
            if (memberData.role.length > value.length) return;
            if (memberData.role.includes('STAFF')) {
                if(value.includes('STAFF') && value.includes('COACH')){
                    const newValue = value.filter(item => item !== 'STAFF');
                    setMemberData({ ...memberData, [name]: newValue})
                }else{
                    setMemberData({
                        ...memberData, [name]: value
                    });
                }
            } else if (memberData.role.includes('COACH')) {
                if (value.includes('STAFF') && value.includes('COACH')) {
                    const newValue = value.filter(item => item !== 'COACH');
                    setMemberData({ ...memberData, [name]: newValue })
                }else{
                    setMemberData({
                        ...memberData, [name]: value
                    });
                }
            } else {
                setMemberData({
                    ...memberData, [name]: value
                });
            }
            Object.keys(errors).length != 0 && setErrors({});
        } else {
            // Clean phone number (only digits and +)
            let newVal = value;
            if (name === 'phone') {
                newVal = value.replace(/[^\d+]/g, '');
                // Limit to 15 characters
                if (newVal.length > 15) {
                    newVal = newVal.substring(0, 15);
                }
            }
            setMemberData({ ...memberData, [name]: newVal })
            Object.keys(errors).length != 0 && setErrors({});
        }
    }

    const handleClickOpen = () => {
        setOpenDialog({ isOpen: true, isEdit: false });
    };

    const handleClose = () => {
        Object.keys(errors).length != 0 && setErrors({});
        setOpenDialog({ isOpen: false, isEdit: false });
        setMemberData({ role: ['STAFF'] })
    };

    const handleOpenEditPopup = (userId, role) => {
        setMemberData({ userId: userId, role: role })
        setOpenDialog({ isOpen: true, isEdit: true });
    };

    function capitalize(text) {
        if (!text) return '';
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }

    const handleEditRole = async () => {
        try {
            setLoading(true);
            await UserAPI.updateUserRole(memberData.userId, { roleNames: memberData.role });
            setAllMember(prev => prev.map(item => item.userId === memberData.userId ? { ...item, roles: memberData.role.map(item => capitalize(item)) } : item))
            setOpenDialog({ isOpen: false, isEdit: false });
            setMemberData({ role: ['STAFF'] });
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Loader />;
    }

    const deleteMember = async (userId) => {
        try {
            setLoading(true);
            await UserAPI.deleteClubMember(userId, selectedClub?.clubId);
            setAllMember(prev => prev.filter(item => item.userId !== userId));
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: 'Member deleted successfully' }));
        } catch (error) {
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: error?.response?.data?.Data ? error?.response?.data?.Data : 'Please contact customer support' }));
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className='invite_staff_main_container'>
            <h1>Manage members</h1>
            <div className='invite_staff_container'>
                <div className='invite_staff_header'>
                    <h3>Member</h3>
                    {privileges?.MANAGE_INVITE_STAFF?.includes(Privileges.SEND) &&
                        <h4 onClick={() => handleClickOpen()}><TiUserAdd className='invite_staff_add_member_icon' /> Add member</h4>}
                </div>
                {allMember?.length != 0 ?
                    <div className='invite_staff_body'>
                        {allMember?.map((item, index) =>
                            <React.Fragment key={index}>
                                <RowDataItem key={index}
                                    userData={item}
                                    deleteMember={deleteMember}
                                    privileges={privileges}
                                    handleOpenEditPopup={handleOpenEditPopup}
                                />
                                {index < allMember?.length - 1 && <hr className='invite_staff_horizontal_line' />}
                            </React.Fragment>)}
                    </div>
                    :
                    <div className='invite_staff_body_not_found'>
                        <div className='invite_staff_body_not_found_body'>
                            <img src={notFoundImg} alt="" />
                            <p>No member found</p>
                        </div>
                    </div>}
            </div>

            <CustomDialog
                title={openDialog.isEdit ? "Edit Member Role" : "Add Staff"}
                isOpen={openDialog.isOpen}
                onClose={() => handleClose()}
                onCancel={() => handleClose()}
                onSubmit={openDialog.isEdit ? handleEditRole : handleCreateMemberUser}
                submitBtnName={openDialog.isEdit ? 'Save' : 'Invite'}
            >
                <div className="add-member-form">
                    {!openDialog.isEdit &&
                        <>
                            <div className="member-name-input">
                                <TextField
                                    className="add-member-text-input"
                                    error={!!errors.firstName}
                                    helperText={errors.firstName && errors.firstName}
                                    variant="outlined"
                                    name="firstName"
                                    inputProps={{ maxLength: 100 }}
                                    value={memberData.firstName || ''}
                                    onChange={handleMemberData}
                                    label="First Name *" 
                                    fullWidth
                                />
                                <TextField
                                    className="add-member-text-input"
                                    error={!!errors.lastName}
                                    inputProps={{ maxLength: 100 }}
                                    helperText={errors.lastName && errors.lastName}
                                    variant="outlined"
                                    value={memberData.lastName || ''}
                                    onChange={handleMemberData}
                                    name="lastName"
                                    label="Last Name *" 
                                    fullWidth
                                />
                            </div>
                            <div className="member-email-input">
                                <TextField 
                                    fullWidth
                                    className="add-member-text-input"
                                    error={!!errors.email}
                                    inputProps={{ maxLength: 100 }}
                                    helperText={errors.email && errors.email}
                                    variant="outlined"
                                    value={memberData.email || ''}
                                    onChange={handleMemberData}
                                    label='Email *'
                                    name='email' 
                                />
                            </div>
                            <div className="member-email-mobile">
                                <TextField
                                    fullWidth
                                    className="add-member-text-input"
                                    error={!!errors.phone}
                                    helperText={errors.phone && errors.phone}
                                    variant="outlined"
                                    name="phone"
                                    inputProps={{ maxLength: 15 }}
                                    value={memberData.phone || ''}
                                    onChange={handleMemberData}
                                    label="Phone"
                                    placeholder="+1234567890"
                                />
                            </div>
                        </>
                    }
                    <FormControl sx={{ width: '100%' }}
                        className="signup-text-input"
                        error={!!errors.role}
                    >
                        <InputLabel id="demo-multiple-chip-label">Role</InputLabel>
                        <Select
                            labelId="demo-multiple-chip-label"
                            id="demo-multiple-chip"
                            multiple
                            value={memberData.role ?? []}
                            name='role'
                            onChange={handleMemberData}
                            input={<OutlinedInput id="select-multiple-chip" label="Role" />}
                            renderValue={(selected) => (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                    {selected.map((value) => (
                                        <Chip key={value} onMouseDown={(event) => event.stopPropagation()} label={value} clickable={true} onDelete={() => {
                                            if (value !== 'STAFF' && value !== 'COACH') {
                                                setMemberData(prev => ({ ...prev, role: prev.role.filter(item => item !== value) }))
                                            }
                                        }} />
                                    ))}
                                </Box>
                            )}
                            MenuProps={MenuProps}
                        >
                            <MenuItem value="STAFF">STAFF</MenuItem>
                            <MenuItem value="COACH">COACH</MenuItem>
                        </Select>
                        {errors.role && (
                            <FormHelperText sx={{ color: "red" }}>
                                {errors.role}
                            </FormHelperText>
                        )}
                    </FormControl>
                </div>
            </CustomDialog>
        </div>
    )
}

export default InviteStaff